module.exports = __webpack_public_path__ + "img/transparent-black.248cf169.png";